import { useState, useEffect, useContext } from 'react'
import { Link, useLocation, useParams, useNavigate } from 'react-router-dom';
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

import { MdOutlineLocalPrintshop, MdOutlineFactCheck, MdOutlineMoreTime, MdOutlineTextIncrease, MdOutlineTextDecrease, MdOutlineFileDownload, MdCheckBoxOutlineBlank } from "react-icons/md";
import { AiOutlineAppstoreAdd } from "react-icons/ai";
import { PiStudent, PiPencil, PiBuildingsLight } from "react-icons/pi";
import { GoTasklist } from "react-icons/go";
import { LuTimer } from "react-icons/lu";


import './css/view.css'

import { AppContext } from "../../Context";
import Question from './components/question'
import Fetch, { Loader, GET, ClassToName, SecoundsToTime, DateToText } from "../../inc/Fetch"; 
import Header from "./Header";
import Permission from "../Permission";
import { ScoreAndNotes } from "./components/Ready";
import { Img } from "../../components/Elements";

export default function ViewStudentTask({action}) {

    const { t } = useTranslation();
    let location = useLocation();
    let params = useParams();
    let navigate = useNavigate();

    const { successData, userData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;

    const [show, setshow] = useState(0);
    const [answers, setanswers] = useState({});
    const [loading, setloading] = useState(false);

    const [showanswers, setshowanswers] = useState("");
    const [fontsize, setfontsize] = useState(12);
    const [activity, setactivity] = useState(false);
    const [values, setvalues] = useState({});
    const [notes, setnotes] = useState([]);

    async function loadData() {

        let r = await GET(`task/student_task_view/?_id=${params?.id}&student=${params?.student}`);

        setvalues({
            status: r?.task?.status,
            score: r?.task?.score,
        });
        return r;
    }

    function updateScore(d) {

        d = Number(d);

        if (d >= 100) {
            d = 100;
        }

        if (d <= 0) {
            d = 0;
        }

        setvalues(p => ({
            ...p,
            score:d,
        }))
    }

    const { data, error, isLoading } = useQuery(`view_student_task_${params?.id}_${params?.student}`, loadData); 

    

    function fontSizeCg(st) {

        if (st) {
            setfontsize(p => p <= 12 ? 12 :  p - 2);
        } else {
            setfontsize(p => p >= 18 ? 18 :  p + 2);
        }
        
    }

    function saveAnswers(d, k) {
        setanswers(p => ({
            ...p,
            [k]:d
        }));
    }

    function submit() {
        setloading(true);
        Fetch("task/updateTaskScore", (d) => {

            if (d?.error) {
                setopen({ error:true, short: t("error",  { returnObjects: true })[d?.error] });
            } else {
                setopen({ error:false, short: t("score_updated") });

                setTimeout(() => {
                    navigate(-1);
                }, 2500);
            }

            setloading(false);
            
        }, { data:values, student: params?.student, _id: params?.id, notes:notes });
        
    }

    function notesSave(e, id) {

        let ins = {
            note:e,
            id: id
        };

        setnotes(p => p?.length ? [...p?.filter(r => r?.id != id), ins] : [ins]);
    }

    if (isLoading) {
        return <Loader />
    }
    
    if (!data?.task?._id) {
        return <Permission />
    }

    let task = data?.task?.task;
    
    return (
        <>
            <div className='taskNewBody'>
                
                <Header />

                <div className='rightTaskMenu'>

                    <a onClick={() => fontSizeCg()} >
                        <MdOutlineTextIncrease />
                        <span>{t("task_start_opt_7")}</span>
                    </a>
                    <a onClick={() => fontSizeCg(true)}>
                        <MdOutlineTextDecrease />
                        <span>{t("task_start_opt_8")}</span>
                    </a>

                    
                </div>
                
                <div className={`mainWidth taskMainNewBox f-${fontsize}`}>
                    <div className='mainTitleBox'>
                        <div>
                            <h1 className='mainTitle'>{task?.title}</h1>
                            <nav>
                                <a className='tagInfo'>{task?.task?.cat?.name}</a>
                                <a className='tagInfo'>{t("class")} <ClassToName classes={task?.classes} /></a>
                            </nav>
                        </div>
                        
                    </div>

                    <div className='tasksStatsBox' style={{padding:0, backgroundColor:"transparent", border:0}}>
                        <div className='studentInfoBox'>
                            <hr />
                            <Img src={`img/80/${data?.task?.user?.img}`} />
                            <p>
                                <h2>{data?.task?.user?.name}</h2>
                                
                                <nav>
                                    <span className={`tag ${data?.task?.status == 1 && 'orange'} ${data?.task?.status == 2 && 'blue'}`}><GoTasklist />{t(`task_student_status_${data?.task?.status || '0'}`)}</span>
                                    <span className={`tag blue`}><LuTimer /><SecoundsToTime time={data?.task?.timer}/></span>
                                    <span className={`tag blue`}><MdOutlineMoreTime /><DateToText time={data?.task?.date} /></span>

                                </nav>
                            </p>
                        </div>
                        <div >
                            <hr />
                            <p>
                                <b>{data?.task?.score}%</b>
                                <span>{t("score_student")}</span>
                            </p>
                            <PiPencil />
                        </div>

                    </div>

                    {task?.story &&  <div className='storySection shadow'>
                        <h6 className='sectionTigtle'><div className="triangle-up"></div>{t("task_new_text")}</h6>
                        <div className='storyBoxText' dangerouslySetInnerHTML={ {__html: task?.story}} />
                    </div>}

                    <div className='questionsBoxNewTitle'>
                        <hr />
                        <span>{t("tasks_questions_number")} ({task?.questions?.length})</span>
                        <hr />
                    </div>

                    <div className='quizNewMainBox'>
                        {task?.questions?.map((v, k) => {

                            let answers;
                            if (data?.task?.answers?.length) {
                                answers = data?.task?.answers[k];
                            }

                            
                            return (
                                <div className='storySection shadow grayBg'>
                                    <Question st_answers={answers || false} k={k} response={(d) => saveAnswers(d, v?.id)} key={k} data={v} show={true} showAnswers={showanswers || ""}/>
                                    <ScoreAndNotes score={answers?.score} note={answers?.note} onChange={(e) => notesSave(e, v?.id)} />
                                </div>
                            );
                        })}
                    </div>

                    <div className='questionsAllScoresBox shadow'>

                        <div class="questionTaskResultBox">
                            <p></p>
                            <div>
                                <span style={{color:"#555"}}>{t("task_student_status_2")}</span>
                                <select onChange={(d) => setvalues(p => ({
                                    ...p,
                                    status:Number(d.target.value),
                                }))}>
                                    <option value='1' selected={values?.status == 1 ? true : false}>{t(`task_student_status_1`)}</option>
                                    <option value='2' selected={values?.status == 2 ? true : false}>{t(`task_student_status_2`)}</option>
                                </select>
                            </div>
                        </div>

                        <div class="questionTaskResultBox">
                            <p></p>
                            <div>
                                <span style={{ color:"#111"}}>{t("task_student_status_2")}</span>
                                <input 
                                    type="number" 
                                    name='score' 
                                    onChange={(v) => updateScore(v?.target?.value)}
                                    value={values?.score} 
                                />

                            </div>

                        </div>

                        <button onClick={submit} className='btn'>{t("task_update_score")}</button>

                    </div>
                   
                </div>
               
            </div>
        </>
    )
}
